export const handleKeyPress = (event) => {
  if (event.key === "e") {
    event.preventDefault();
  }
};
